import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_RATA_FATTURA } from '../../data.const';
import {
  setCurrentRataFatturaAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveRataFatturaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_RATA_FATTURA),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_RATA_FATTURA}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ fatturaLoader: true })),
        defer(() =>
          from(
            request({ path: `rataFattura/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_RATA_FATTURA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentRataFatturaAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_RATA_FATTURA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ fatturaLoader: false }))
      );
    })
  );

export default retrieveRataFatturaEpic;
